import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { ACTIVITY_TYPES, CALL_TYPES } from '../constants';

export const ActivityDialog = ({ 
  open, 
  onOpenChange, 
  leadId,
  newActivity, 
  setNewActivity, 
  onSubmit 
}) => {
  return (
    <Dialog open={open} onOpenChange={(o) => onOpenChange({ open: o, leadId: o ? leadId : null })}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Log Activity</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>Activity Type</Label>
            <Select value={newActivity.activity_type} onValueChange={(v) => setNewActivity({...newActivity, activity_type: v})}>
              <SelectTrigger data-testid="activity-type-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {ACTIVITY_TYPES.map(t => (
                  <SelectItem key={t.value} value={t.value}>
                    <div className="flex items-center gap-2">
                      <t.icon className="h-4 w-4" />
                      {t.label}
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {newActivity.activity_type === 'call' && (
            <div className="space-y-2">
              <Label>Call Type</Label>
              <Select value={newActivity.call_type} onValueChange={(v) => setNewActivity({...newActivity, call_type: v})}>
                <SelectTrigger data-testid="call-type-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {CALL_TYPES.map(t => (
                    <SelectItem key={t.value} value={t.value}>
                      <div className="flex items-center gap-2">
                        <t.icon className="h-4 w-4" />
                        {t.label}
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}

          <div className="space-y-2">
            <Label>Title *</Label>
            <Input 
              value={newActivity.title}
              onChange={(e) => setNewActivity({...newActivity, title: e.target.value})}
              placeholder="e.g., Called to discuss pricing"
              data-testid="activity-title-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Outcome</Label>
            <Select value={newActivity.outcome} onValueChange={(v) => setNewActivity({...newActivity, outcome: v})}>
              <SelectTrigger data-testid="activity-outcome-select">
                <SelectValue placeholder="Select outcome" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="interested">Interested</SelectItem>
                <SelectItem value="not_available">Not Available</SelectItem>
                <SelectItem value="callback_requested">Callback Requested</SelectItem>
                <SelectItem value="site_visit_scheduled">Site Visit Scheduled</SelectItem>
                <SelectItem value="not_interested">Not Interested</SelectItem>
                <SelectItem value="wrong_number">Wrong Number</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Duration (minutes)</Label>
            <Input 
              type="number"
              value={newActivity.duration_minutes}
              onChange={(e) => setNewActivity({...newActivity, duration_minutes: e.target.value})}
              placeholder="e.g., 15"
              data-testid="activity-duration-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Notes</Label>
            <Textarea 
              value={newActivity.description}
              onChange={(e) => setNewActivity({...newActivity, description: e.target.value})}
              placeholder="Additional notes..."
              rows={3}
              data-testid="activity-notes-input"
            />
          </div>
        </div>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange({ open: false, leadId: null })}>Cancel</Button>
          <Button onClick={onSubmit} data-testid="save-activity-btn">Log Activity</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
